import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createSlots as _createSlots, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "declaration-container" }
const _hoisted_2 = {
  key: 0,
  class: "validation-summary"
}
const _hoisted_3 = { class: "button-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TranslatedText = _resolveComponent("TranslatedText")!
  const _component_ActionHeader = _resolveComponent("ActionHeader")!
  const _component_UserForm = _resolveComponent("UserForm")!
  const _component_AddressList = _resolveComponent("AddressList")!
  const _component_ContactNumberList = _resolveComponent("ContactNumberList")!
  const _component_EmergencyContactList = _resolveComponent("EmergencyContactList")!
  const _component_PayrollForm = _resolveComponent("PayrollForm")!
  const _component_Declaration = _resolveComponent("Declaration")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Signature = _resolveComponent("Signature")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_ActionHeader, {
      hotspotDescription: _ctx.hotspotDescription,
      actionTitle: _ctx.actionTitle,
      actionDescription: _ctx.actionDescription
    }, _createSlots({ _: 2 }, [
      (!_ctx.actionProgress?.completed)
        ? {
            name: "description",
            fn: _withCtx(() => [
              _createElementVNode("p", null, [
                _createVNode(_component_TranslatedText, { path: "form.all.required" })
              ])
            ]),
            key: "0"
          }
        : undefined
    ]), 1032, ["hotspotDescription", "actionTitle", "actionDescription"]),
    _createVNode(_component_UserForm, {
      modelValue: _ctx.userDetails,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.userDetails) = $event)),
      errors: _ctx.errors,
      "onUpdate:errors": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.errors) = $event)),
      isValid: _ctx.detailsIsValid,
      "onUpdate:isValid": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.detailsIsValid) = $event)),
      submitCheck: _ctx.submitCheck,
      "onUpdate:submitCheck": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.submitCheck) = $event)),
      genders: _ctx.genders,
      languages: _ctx.languages,
      readonly: _ctx.actionProgress?.completed,
      formQuestions: _ctx.formQuestions,
      userResponses: _ctx.userResponses,
      hiddenUserFields: _ctx.hiddenUserFields,
      formSchemaChanges: _ctx.formSchemaChanges,
      onDoChange: _ctx.handleDoChange,
      onSelectChange: _ctx.handleSelectChange,
      onChoiceChange: _ctx.handleChoiceChange,
      onCheckboxChange: _ctx.handleCheckboxChange
    }, null, 8, ["modelValue", "errors", "isValid", "submitCheck", "genders", "languages", "readonly", "formQuestions", "userResponses", "hiddenUserFields", "formSchemaChanges", "onDoChange", "onSelectChange", "onChoiceChange", "onCheckboxChange"]),
    _cache[13] || (_cache[13] = _createElementVNode("hr", null, null, -1)),
    _createElementVNode("h2", {
      class: _normalizeClass(["type-subtitle-02", { error: !_ctx.addressesIsValid }])
    }, [
      _createVNode(_component_TranslatedText, { path: "models.contact-details.title" }),
      _createVNode(_component_TranslatedText, {
        path: "form.required.asterix",
        class: "required-asterix"
      })
    ], 2),
    _createVNode(_component_AddressList, {
      addresses: _ctx.addresses,
      "hide-primary": true,
      readonly: _ctx.actionProgress?.completed,
      onSave: _ctx.handleSaveAddress,
      onDelete: _ctx.handleDeleteAddress
    }, null, 8, ["addresses", "readonly", "onSave", "onDelete"]),
    _cache[14] || (_cache[14] = _createElementVNode("hr", null, null, -1)),
    _createElementVNode("h2", {
      class: _normalizeClass(["type-subtitle-02", {
        error: _ctx.contactNumberRequired && _ctx.contactNumberRequired.length <= 0,
      }])
    }, [
      _createVNode(_component_TranslatedText, { path: "models.contact-number.plural" }),
      (_ctx.contactNumberRequired)
        ? (_openBlock(), _createBlock(_component_TranslatedText, {
            key: 0,
            path: "form.required.asterix",
            class: "required-asterix"
          }))
        : _createCommentVNode("", true)
    ], 2),
    _createVNode(_component_ContactNumberList, {
      contactNumbers: _ctx.contactNumbers,
      limit: 1,
      "hide-primary": true,
      readonly: _ctx.actionProgress?.completed,
      onSave: _ctx.handleSaveNumber,
      onDelete: _ctx.handleDeleteNumber
    }, null, 8, ["contactNumbers", "readonly", "onSave", "onDelete"]),
    _cache[15] || (_cache[15] = _createElementVNode("hr", null, null, -1)),
    _createElementVNode("h2", {
      class: _normalizeClass(["type-subtitle-02", {
        error: _ctx.emergencyContactRequired && _ctx.emergencyContacts.length <= 0,
      }])
    }, [
      _createVNode(_component_TranslatedText, { path: "models.emergency-contact.plural" }),
      (_ctx.emergencyContactRequired)
        ? (_openBlock(), _createBlock(_component_TranslatedText, {
            key: 0,
            path: "form.required.asterix",
            class: "required-asterix"
          }))
        : _createCommentVNode("", true)
    ], 2),
    _createVNode(_component_EmergencyContactList, {
      contacts: _ctx.emergencyContacts,
      limit: 1,
      "hide-primary": true,
      readonly: _ctx.actionProgress?.completed,
      telephoneRequired: !!_ctx.emergencyContactRequired,
      onSave: _ctx.handleSaveContact,
      onDelete: _ctx.handleDeleteContact
    }, null, 8, ["contacts", "readonly", "telephoneRequired", "onSave", "onDelete"]),
    _cache[16] || (_cache[16] = _createElementVNode("hr", null, null, -1)),
    _createElementVNode("h2", {
      class: _normalizeClass(["type-subtitle-02", { error: !_ctx.payrollIsValid }])
    }, [
      _createVNode(_component_TranslatedText, { path: "form.bank-details" }),
      _createVNode(_component_TranslatedText, {
        path: "form.required.asterix",
        class: "required-asterix"
      })
    ], 2),
    _createVNode(_component_PayrollForm, {
      modelValue: _ctx.payroll,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.payroll) = $event)),
      errors: _ctx.payrollErrors,
      "onUpdate:errors": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.payrollErrors) = $event)),
      isValid: _ctx.payrollIsValid,
      "onUpdate:isValid": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.payrollIsValid) = $event)),
      readonly: _ctx.actionProgress?.completed,
      bankAddressDisplayed: _ctx.bankAddressDisplayed,
      "onUpdate:payroll": _ctx.handlePayrollUpdate
    }, null, 8, ["modelValue", "errors", "isValid", "readonly", "bankAddressDisplayed", "onUpdate:payroll"]),
    _cache[17] || (_cache[17] = _createElementVNode("hr", null, null, -1)),
    _createElementVNode("div", _hoisted_1, [
      (_ctx.showValidationSummary && _ctx.validationErrors.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _cache[11] || (_cache[11] = _createElementVNode("h3", null, "Please complete the following required sections:", -1)),
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validationErrors, (error) => {
                return (_openBlock(), _createElementBlock("li", { key: error }, _toDisplayString(error), 1))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.actionProgress?.completed)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createVNode(_component_TranslatedText, { path: "declaration.sign.complete" }),
            _cache[12] || (_cache[12] = _createTextVNode(" - ", -1)),
            _createElementVNode("span", null, _toDisplayString(_ctx.completionDateString), 1)
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            (!_ctx.wetSignature)
              ? (_openBlock(), _createBlock(_component_Declaration, {
                  key: 0,
                  modelValue: _ctx.declaration,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.declaration) = $event)),
                  isValid: _ctx.declarationIsValid,
                  "onUpdate:isValid": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.declarationIsValid) = $event)),
                  line1: "declaration.new-starter.main",
                  line2: "declaration.new-starter.sub"
                }, null, 8, ["modelValue", "isValid"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_Button, {
                text: "declaration.sign",
                disabled: !_ctx.isDirty,
                onClick: _ctx.handleSignClick
              }, null, 8, ["disabled", "onClick"])
            ]),
            _createVNode(_component_Modal, {
              modelValue: _ctx.showSignModal,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.showSignModal) = $event)),
              title: "signature.title",
              showFooter: false,
              onCancel: _ctx.handleModalHide
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Signature, {
                  modelValue: _ctx.declarationWet,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.declarationWet) = $event)),
                  onConfirm: _ctx.handleSignSubmit,
                  onCancel: _ctx.handleModalHide
                }, null, 8, ["modelValue", "onConfirm", "onCancel"])
              ]),
              _: 1
            }, 8, ["modelValue", "onCancel"])
          ], 64))
    ])
  ]))
}